export const BUSCAR_TDOCS = "BUSCAR_TDOCS";
export const MODIFICAR_FILTROS = "MODIFICAR_FILTROS";
export const CARGANDO_CONTROL = "CARGANDO_CONTROL";
export const REINICIAR_FILTROS = "REINICIAR_FILTROS";
export const CAMBIAR_VIEW_FROM = "CAMBIAR_VIEW_FROM";
export const SELECCIONAR_TDOC = "SELECCIONAR_TDOC"; 
export const ACTUALIZAR_TDOC = "ACTUALIZAR_TDOC";
export const AGREGAR_TDOC = "AGREGAR_TDOC";
export const DELETE_TDOC = "DELETE_TDOC";
export const APLICAR_FILTROS = "APLICAR_FILTROS";
export const INICIALIZAR_FILTROS = "INICIALIZAR_FILTROS";

//Nueva logica
export const MODIFICAR_FILTROS_ESTADOS = "MODIFICAR_FILTROS_ESTADOS"; 
export const MODIFICAR_FILTROS_RANGO = "MODIFICAR_FILTROS_RANGO";
export const SET_TDOCS = "SET_TDOCS";
export const MERGE_TDOCS = "MERGE_TDOCS";
export const SET_TDOCS_REPORTE = "SET_TDOCS_REPORTE";
export const INICIAR_FILTROS = "INICIAR_FILTROS"; 

export const INICIAR_FILTROS_DASHBOARDODT = "INICIAR_FILTROS_DASHBOARDODT"; 
export const SET_INFO_DASHBOARDODT = "SET_INFO_DASHBOARDODT"; 